// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1v8hQ","empty":"ModalGraph_empty__1LYUz"};